import { motion } from "framer-motion";
import { Check, Loader2, X } from "lucide-react";
import { cn } from "@/lib/cn";

// The live plan: each step animates pending → running → done / fail.
function StepIcon({ status }) {
  if (status === "done")
    return (
      <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-500 text-white">
        <Check size={12} strokeWidth={3} />
      </span>
    );
  if (status === "fail")
    return (
      <span className="grid h-5 w-5 place-items-center rounded-full bg-rose-500 text-white">
        <X size={12} strokeWidth={3} />
      </span>
    );
  if (status === "running")
    return (
      <span className="grid h-5 w-5 place-items-center rounded-full bg-brand-500/15 text-brand-500">
        <Loader2 size={13} className="animate-spin" />
      </span>
    );
  return (
    <span className="h-5 w-5 rounded-full border-2 border-dashed border-slate-300 dark:border-white/20" />
  );
}

export default function PlanView({ steps }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-3 dark:border-white/10 dark:bg-white/5">
      <p className="mb-2 px-1 text-xs font-semibold uppercase tracking-wide text-slate-400">
        Plan — {steps.length} steps
      </p>
      <ul className="space-y-1">
        {steps.map((step, i) => (
          <motion.li
            key={step.label}
            initial={{ opacity: 0, x: -6 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.05 }}
            className={cn(
              "flex items-center gap-2.5 rounded-lg px-2 py-1.5 text-sm transition-colors",
              step.status === "running" && "bg-brand-500/5",
              step.status === "fail" && "bg-rose-500/5"
            )}
          >
            <StepIcon status={step.status} />
            <span
              className={cn(
                "leading-tight",
                step.status === "pending" && "text-slate-400",
                step.status === "running" &&
                  "font-medium text-slate-800 dark:text-slate-100",
                step.status === "done" && "text-slate-600 dark:text-slate-300",
                step.status === "fail" &&
                  "font-medium text-rose-600 dark:text-rose-300"
              )}
            >
              {step.label}
            </span>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}
